import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { IconButton } from "@similarweb/ui-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import type { ComponentProps } from "react";

export const StyledBox = styled(Box)<{
    maxHeight: string;
    minHeight?: string;
}>`
    display: flex;
    flex-direction: column;
    max-height: ${({ maxHeight }) => maxHeight};
    min-height: ${({ minHeight }) => minHeight};
    width: 100%;
    height: auto;
    margin-bottom: 24px;
`;

const StyledIconButton = styled(IconButton)`
    min-width: 156px;
`;

export const CtaWrapper = styled(CenteredFlexRow)`
    height: 100px;
    width: 100%;
    button {
        > div:nth-child(2) {
            text-transform: inherit;
        }
    }
`;

export const CtaLoaderWrapper = styled(CenteredFlexRow)`
    height: 100px;
    width: 100%;
    position: relative;
    svg {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 36px;
        width: 100px;
        position: absolute;
        border-radius: 69px;
        rect {
            /* ButtonPlaceholderLoader */
            width: 120px;
        }
    }
`;

export const TitleWrapper = styled.div<{ marginBottom?: string }>`
    margin: 24px;
    ${({ marginBottom }) => marginBottom && `margin-bottom:${marginBottom}`};
`;

export const ContentWrapper = styled(FlexColumn)<
    ComponentProps<typeof FlexColumn> & { height?: string; isNoData?: boolean }
>`
    padding: 0 24px;
    ${({ height }) => height && `height:${height}`};
    ${({ isNoData }) => isNoData && `padding-bottom: 120px;`};
`;
